/**
 * Task QR + iOS: QR membership sign-up from the POS (待付款 list, regenerate / cancel / resend) and App Store readiness
 * (account deletion, neutral "manage your account on senviapos.com" text in the store app).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["qr.gen","Generate QR","生成二维码"],
  ["qr.seller.required","Choose the responsible staff (负责人) — commission is credited to them.","请选择负责人——佣金将计给此人。"],
  ["qr.title","Scan to join","扫码订阅"],
  // why "Generate QR" can't run yet (shown next to the button)
  ["qr.need.customer","Choose the customer first (top of this form).","请先选择顾客（在本表单顶部）。"],
  ["qr.need.plan","Choose a plan.","请选择订阅方案。"],
  ["qr.need.staff","Choose the responsible staff (负责人).","请选择负责人。"],
  ["qr.need.ready","Subscriptions can't be sold here yet — see the message at the top.","暂时无法在此销售订阅——请查看顶部提示。"],
  ["qr.cust.change","Change","更换"],
  ["qr.scan","Ask the customer to scan with their phone camera. They check their details, accept the terms and pay by card on their own phone.","请顾客用手机相机扫码，在自己的手机上确认资料、同意条款并用银行卡付款。"],
  ["qr.expiresIn","Expires in {time}","{time} 后过期"],
  ["qr.expired","The QR code has expired. Generate a new one — it stays the same sign-up.","二维码已过期，请重新生成（仍是同一笔订阅）。"],
  ["qr.regen","Regenerate","重新生成"],
  ["qr.copy","Copy link","复制链接"],
  ["qr.copied","Link copied","链接已复制"],
  ["qr.cancel","Cancel sign-up","取消订阅"],
  ["qr.cancel.title","Cancel this sign-up?","取消此订阅？"],
  ["qr.cancel.body","The pending record is voided and the QR / link stops working. Nothing has been charged.","待付款记录将作废，二维码 / 链接立即失效。不会产生任何扣款。"],
  ["qr.cancelled","Sign-up cancelled","已取消订阅"],
  ["qr.waiting","Waiting for payment…","等待付款…"],
  ["qr.done","已订阅 — the customer has paid. The subscription is active.","已订阅——顾客已付款，订阅已生效。"],
  ["qr.close","Done","完成"],
  ["qr.demoPay","Open sign-up page (demo)","打开订阅页面（演示）"],
  ["qr.pendingNote","Saved as 待付款 (pending payment) under {seller}.","已保存为待付款，负责人：{seller}。"],
  ["qr.tab.pending","Pending payment","待付款"],
  ["qr.pending.help","Sign-ups created at the POS that the customer hasn't paid yet. Resend the link (valid 24 hours) or cancel.","在收银台创建、顾客尚未付款的订阅。可重发链接（24 小时内有效）或取消。"],
  ["qr.resend","Resend link","重发链接"],
  ["qr.resent","Link ready (valid 24 hours) — copied","链接已生成（24 小时有效），已复制"],
  ["qr.created","Created {date}","创建于 {date}"],
  ["qr.void","Cancel","取消"],
  ["qr.st.pending","Pending payment","待付款"],
  ["an.wa.signup","Send link via WhatsApp","用 WhatsApp 发送链接"],
  ["acct.nav","Account","账户"],
  ["acct.title","Account","账户"],
  ["acct.manage","Manage your account on senviapos.com","请在 senviapos.com 管理您的账户"],
  ["acct.login.title","Delete my login","删除我的登录账号"],
  ["acct.login.body","Your login is disabled at once and you are signed out on every device. Your name, e-mail and password are erased after {days} days. Sales, payroll and attendance records the shop must keep stay with the shop without your personal details.","您的登录账号会立即停用，并在所有设备上退出。{days} 天后清除您的姓名、电子邮件和密码。店铺依法需保留的销售、薪资和考勤记录将保留，但不再包含您的个人资料。"],
  ["acct.login.btn","Delete my login","删除我的登录账号"],
  ["acct.shop.title","Delete shop account","删除店铺账户"],
  ["acct.shop.body","Deletes the shop \"{shop}\" and all its logins. The shop keeps working for {days} days (you can cancel); then everyone is signed out and customers' personal data is erased. Financial records are kept only as long as the law requires.","删除店铺「{shop}」及其所有登录账号。店铺在 {days} 天内仍可使用（可随时取消）；之后所有人退出登录，顾客个人资料将被清除。财务记录仅按法律要求的期限保留。"],
  ["acct.shop.btn","Delete shop account","删除店铺账户"],
  ["acct.shop.scheduled","Deletion scheduled: the shop will be closed and erased on {date}.","已安排删除：店铺将于 {date} 关闭并清除。"],
  ["acct.shop.undo","Cancel deletion","取消删除"],
  ["acct.shop.undone","Deletion cancelled","已取消删除"],
  ["acct.password","Password","密码"],
  ["acct.confirmWord","Type DELETE to confirm","输入 DELETE 确认"],
  ["acct.confirmShop","Type the shop name to confirm","输入店铺名称确认"],
  ["acct.confirm.title","Delete permanently?","确定永久删除？"],
  ["acct.confirm.go","Delete","删除"],
  ["acct.email","A confirmation e-mail is sent to your address.","确认邮件将发送到您的邮箱。"],
  ["acct.loginDeleted","Your login has been deleted.","您的登录账号已删除。"],
  ["acct.billingNote","If your Senvia plan is paid by card, cancel it on the web at senviapos.com.","如 Senvia 方案以银行卡付费，请到网页版 senviapos.com 取消。"],
  ["acct.ownerHint","As the owner you delete the whole shop account below (or hand the shop to another owner on the web first).","作为店主，请在下方删除整个店铺账户（或先在网页版将店铺转交给其他店主）。"],
  ["native.notEnabled","{feature} isn't enabled for this shop.","本店尚未启用{feature}。"],
  ["native.billingBlocked","This action isn't available for this shop right now. Please contact the shop owner.","本店目前无法使用此功能，请联系店主。"],
  ["native.askOwner","Please contact the shop owner.","请联系店主。"],
  ["native.banner.readOnly","This shop is in read-only mode right now. Please contact the shop owner.","本店目前为只读模式，请联系店主。"],
  ["native.banner.suspended","This shop's account is paused right now. Please contact the shop owner.","本店账户目前已暂停，请联系店主。"],
] as const;

export type QrKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<QrKey, string>;

export const taskQR = { en: col(1), zh: col(2), ms: col(1) };
